import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/services/auth.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-force-log-in',
  template: '<span></span>',
})
export class LoginComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.router.getCurrentNavigation();
    this.authService.login();
  }
}
